import { motion } from 'motion/react';
import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { Icon } from 'src/components';
import { colorSchemePreserveAttrs } from 'src/utils/colorScheme';
import { SIDE_DRAWER_WIDTH_PX } from './motion';

// Preserve on these painted surfaces. A wrapper around `position: fixed` would
// collapse the drawers to 0×0 — filter creates a containing block.
export const Backdrop = styled(motion.div).attrs(colorSchemePreserveAttrs)(
  ({ theme }) => css`
    background: ${transparentize(0.45, theme.co.secondary20)};
    cursor: default;
    inset: 0;
    position: fixed;
    z-index: ${theme.zi.modal};
  `,
);

export const Panel = styled(motion.div).attrs(colorSchemePreserveAttrs)(
  ({ theme }) => css`
    background-color: ${theme.co.neutral20};
    bottom: 0;
    box-shadow: ${theme.sh.s2};
    box-sizing: border-box;
    overflow-y: auto;
    padding: ${theme.sz.s8} ${theme.sz.s8} ${theme.sz.s10} ${theme.sz.s8};
    position: fixed;
    right: 0;
    top: 0;
    width: ${SIDE_DRAWER_WIDTH_PX}px;
    z-index: ${theme.zi.modal + 1};

    &:focus {
      box-shadow: none;
    }
  `,
);

export const CloseButton = styled.button(
  ({ theme }) => css`
    background: none;
    border: none;
    position: absolute;
    right: ${theme.sz.s3};
    top: ${theme.sz.s3};
  `,
);

export const CloseIcon = styled(Icon)(
  ({ theme }) => css`
    &,
    svg {
      height: ${theme.sz.s4};
      width: ${theme.sz.s4};
    }
    & * {
      fill: ${theme.co.primary99};
    }
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    color: ${theme.co.primary20};
    font-family: ${theme.DEPRECATED_ty.boing};
    font-size: ${theme.DEPRECATED_ty.larger};
    margin-bottom: ${theme.sz.s8};
    margin-top: 0;
  `,
);
